import React, { useState, useEffect, useRef } from "react";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import "../layout/styles/inline-cgos.css";
import { ChequeCultureLegacy } from "./legacyforms/ChequeCultureLegacy";
import { PrePaiementService } from "../service/PrePaiementService";



export const PrePaiement = () => {

  const prePaiementService = new PrePaiementService();

  useEffect(() => {

  prePaiementService
        .getPrePaiementDto()
        .then((res) => {
          localStorage.setItem('numeroDemandeDetail', res.data.numeroDemandeDetail);
          localStorage.setItem('numcgos', res.data.numcgos);
          prePaiementService.redirectToPaiement(res.data.apiPaiementUrl);
        })
        .catch((err) => {
          window.location = "/#/serviceIndisponible/"+err.response.data.errorId;
        });
  }, []);



  return (
    <div className="grid">
          <ChequeCultureLegacy />

                      <div className="flex justify-content-between mt-3">
                        <Skeleton width="10rem" height="2rem"></Skeleton>
                        <Skeleton width="10rem" height="2rem"></Skeleton>
                      </div>
                      <Skeleton width="100%" height="400px"></Skeleton>
    </div>
  );
};
